/**
 * Lightweight className utility — joins truthy class strings.
 * Drop-in for clsx without the dependency.
 *
 * Usage: cn('base', isActive && 'active', error ? 'error' : '')
 */
const cn = (...classes) => classes.filter(Boolean).join(' ');

export default cn;
